module.exports = __webpack_public_path__ + "static/media/download.a5e1b5ef.svg";